<div class="mb-calc">
  <div class="mb-grid">

    <!-- ================= EINGABEN ================= -->
    <div>
      <div class="mb-card mb-card--spaced">
        <h3 i18n="@@rechner.inputs.title">Ihr Geschäft</h3>

        <button type="button" class="mb-preset" [class.mb-applied]="onPreset()" (click)="applyPreset()">
          <span class="mb-preset-txt">
            <strong i18n="@@rechner.preset.title">Durchschnittlicher marktbox-Kunde</strong>
            <em i18n="@@rechner.preset.subtitle">2.076 € Umsatz · 5,73 € Bon · 48 % Marge – Mittelwert aus den ersten 450 marktbox-Automaten</em>
          </span>
          <span class="mb-preset-cta">
            @if (onPreset()) {
              <ng-container i18n="@@rechner.preset.active">aktiv</ng-container>
            } @else {
              <ng-container i18n="@@rechner.preset.apply">Werte übernehmen</ng-container>
            }
          </span>
        </button>

        <div class="mb-field">
          <div class="mb-label">
            <label for="revenue" i18n="@@rechner.revenue.label">Erwarteter Umsatz pro Monat</label>
            <span class="mb-val">{{ input().revenue | currency:'EUR':'symbol':'1.0-0' }}</span>
          </div>
          <input id="revenue" type="range" min="300" max="6000" step="1"
                 [ngModel]="input().revenue" (ngModelChange)="patch({ revenue: +$event })">
          <div class="mb-scale"><span>{{ 300 | currency:'EUR':'symbol':'1.0-0' }}</span><span>{{ 6000 | currency:'EUR':'symbol':'1.0-0' }}</span></div>
          <p class="mb-hint" i18n="@@rechner.revenue.hint">
            Die ersten 450 marktbox-Automaten liegen im Schnitt bei <strong>2.076 €</strong> –
            die Spanne reicht von 600 € bis 4.800 €.
          </p>
        </div>

        <div class="mb-field">
          <div class="mb-label"><span i18n="@@rechner.segment.label">Was verkaufen Sie?</span></div>
          <div class="mb-seg">
            <button type="button" [attr.aria-pressed]="segment() === 'direktvermarkter'"
                    (click)="selectSegment('direktvermarkter')" i18n="@@rechner.segment.own">Eigene Erzeugnisse</button>
            <button type="button" [attr.aria-pressed]="segment() === 'haendler'"
                    (click)="selectSegment('haendler')" i18n="@@rechner.segment.bought">Zugekaufte Ware</button>
          </div>
          <p class="mb-hint" i18n="@@rechner.segment.hint">
            Ohne Zwischenhandel bleibt mehr hängen: Direktvermarkter liegen bei rund 48 %, im Handel eher 30 %.
          </p>
        </div>

        <div class="mb-field">
          <div class="mb-label">
            <label for="margin" i18n="@@rechner.margin.label">Rohertragsmarge</label>
            <span class="mb-val">{{ input().margin }} %</span>
          </div>
          <input id="margin" type="range" min="15" max="75" step="1"
                 [ngModel]="input().margin" (ngModelChange)="patch({ margin: +$event })">
          <div class="mb-scale"><span>15 %</span><span>75 %</span></div>
          <p class="mb-hint" i18n="@@rechner.margin.hint">Was vom Verkaufspreis nach Wareneinsatz übrig bleibt.</p>
        </div>

        <div class="mb-field">
          <div class="mb-label">
            <label for="basket" i18n="@@rechner.basket.label">Ø Einkaufswert pro Kunde</label>
            <span class="mb-val">{{ input().basket | currency:'EUR':'symbol':'1.2-2' }}</span>
          </div>
          <input id="basket" type="range" min="2" max="30" step="0.01"
                 [ngModel]="input().basket" (ngModelChange)="patch({ basket: +$event })">
          <div class="mb-scale"><span>{{ 2 | currency:'EUR':'symbol':'1.0-0' }}</span><span>{{ 30 | currency:'EUR':'symbol':'1.0-0' }}</span></div>
          <p class="mb-hint" i18n="@@rechner.basket.hint">
            Über alle Automaten hinweg: <strong>5,73 €</strong>. Bestimmt die Zahl der Transaktionen –
            und damit die Gebühren (10 ct pro Kauf).
          </p>
        </div>
      </div>

      <div class="mb-card">
        <h3 i18n="@@rechner.labour.title">Arbeitszeit (optional)</h3>
        <label class="mb-toggle">
          <input type="checkbox" [ngModel]="input().includeLabour"
                 (ngModelChange)="patch({ includeLabour: $event })">
          <ng-container i18n="@@rechner.labour.toggle">Eigene Arbeitszeit mit einrechnen</ng-container>
        </label>

        @if (input().includeLabour) {
          <div class="mb-work">
            <div class="mb-field">
              <div class="mb-label">
                <label for="trips" i18n="@@rechner.labour.trips">Befüllungen pro Woche</label>
                <span class="mb-val">{{ input().tripsPerWeek }}</span>
              </div>
              <input id="trips" type="range" min="1" max="14" step="1"
                     [ngModel]="input().tripsPerWeek" (ngModelChange)="patch({ tripsPerWeek: +$event })">
            </div>

            <div class="mb-field">
              <div class="mb-label">
                <label for="fill" i18n="@@rechner.labour.fill">Minuten pro Befüllung</label>
                <span class="mb-val" i18n="@@rechner.labour.fill.value">{{ input().minutesPerFill }} Min.</span>
              </div>
              <input id="fill" type="range" min="2" max="20" step="1"
                     [ngModel]="input().minutesPerFill" (ngModelChange)="patch({ minutesPerFill: +$event })">
              <p class="mb-hint" i18n="@@rechner.labour.fill.hint">Eine komplette Befüllung dauert erfahrungsgemäß 2–6 Minuten.</p>
            </div>

            <div class="mb-field">
              <div class="mb-label">
                <label for="drive" i18n="@@rechner.labour.drive">Fahrtzeit hin &amp; zurück</label>
                <span class="mb-val" i18n="@@rechner.labour.drive.value">{{ input().minutesDriving }} Min.</span>
              </div>
              <input id="drive" type="range" min="0" max="120" step="5"
                     [ngModel]="input().minutesDriving" (ngModelChange)="patch({ minutesDriving: +$event })">
              <p class="mb-hint" i18n="@@rechner.labour.drive.hint">0 Minuten, wenn die Box direkt am Hof oder vor dem Laden steht.</p>
            </div>

            <div class="mb-field">
              <div class="mb-label">
                <label for="wage" i18n="@@rechner.labour.wage">Ihr Stundensatz</label>
                <span class="mb-val">{{ input().hourlyWage | currency:'EUR':'symbol':'1.0-0' }}</span>
              </div>
              <input id="wage" type="range" min="0" max="80" step="1"
                     [ngModel]="input().hourlyWage" (ngModelChange)="patch({ hourlyWage: +$event })">
            </div>
          </div>
        }
      </div>
    </div>

    <!-- ================= ERGEBNIS ================= -->
    <div>
      <div class="mb-result" [class.mb-neg]="result().monthlySurplus <= 0">
        <p class="mb-headline" i18n="@@rechner.result.headline">Amortisation beim Kauf</p>

        @if (result().breakevenMonths === null) {
          <p class="mb-big" i18n="@@rechner.result.never">Trägt sich <small>noch nicht</small></p>
          <p class="mb-note" i18n="@@rechner.result.never.note">
            Mit diesen Werten deckt der Rohertrag die laufenden Kosten nicht.
            Stellschrauben: Umsatz, Marge – oder die Fahrtzeit.
          </p>
        } @else {
          <p class="mb-big" i18n="@@rechner.result.months">
            {{ result().breakevenMonths | number:'1.1-1' }} <small>Monate</small>
          </p>
          <p class="mb-note" i18n="@@rechner.result.months.note">
            Ab dann verdient die Box
            <strong>{{ result().monthlySurplus | currency:'EUR':'symbol':'1.0-0' }}</strong>
            pro Monat für Sie@if (input().includeLabour) { – Ihre Arbeitszeit ist bereits bezahlt}.
          </p>
        }

        <!-- Einordnung gegen die steuerliche Abschreibungsdauer -->
        <div class="mb-bench" [class.mb-over]="!result().withinAfa">
          <p class="mb-bench-txt">
            @if (result().withinAfa) {
              <ng-container i18n="@@rechner.afa.within">Der Fiskus schreibt Verkaufsautomaten über <strong>60 Monate</strong> ab.
              Ihr Automat ist <strong>{{ monthsSavedVsAfa() }} Monate früher</strong> bezahlt –
              also klar im guten Bereich.</ng-container>
            } @else {
              <ng-container i18n="@@rechner.afa.over">Der Fiskus schreibt Verkaufsautomaten über <strong>60 Monate</strong> ab.
              Diese Rechnung liegt darüber – wirtschaftlich wird es eng.</ng-container>
            }
          </p>
          <div class="mb-bench-bar">
            <div class="mb-bench-fill" [style.width.%]="afaProgress() * 100"></div>
          </div>
          <div class="mb-bench-scale">
            <span i18n="@@rechner.afa.scale.buy">Kauf</span><span i18n="@@rechner.afa.scale.term">Abschreibungsdauer: 60 Monate</span>
          </div>
        </div>
      </div>

      <div class="mb-rows">
        <div class="mb-row">
          <span i18n="@@rechner.rows.grossProfit">Rohertrag ({{ input().margin }} % von {{ input().revenue | currency:'EUR':'symbol':'1.0-0' }})</span>
          <span>{{ result().grossProfit | currency:'EUR':'symbol':'1.0-0' }}</span>
        </div>
        <div class="mb-row mb-minus">
          <span i18n="@@rechner.rows.power">Strom (60 W Dauerbetrieb)</span>
          <span>– {{ result().powerCost | currency:'EUR':'symbol':'1.2-2' }}</span>
        </div>
        <div class="mb-row mb-minus">
          <span i18n="@@rechner.rows.fees">Zahlungsgebühren ({{ result().transactions | number:'1.0-0' }} Transaktionen)</span>
          <span>– {{ result().transactionCost | currency:'EUR':'symbol':'1.2-2' }}</span>
        </div>
        <div class="mb-row mb-minus">
          <span i18n="@@rechner.rows.insurance">Versicherung</span>
          <span>– {{ result().insuranceCost | currency:'EUR':'symbol':'1.2-2' }}</span>
        </div>
        <div class="mb-row mb-minus">
          <span i18n="@@rechner.rows.mobile">Mobilfunk / IoT</span>
          <span>– {{ result().mobileCost | currency:'EUR':'symbol':'1.2-2' }}</span>
        </div>
        @if (input().includeLabour) {
          <div class="mb-row mb-minus">
            <span i18n="@@rechner.rows.labour">Arbeitszeit ({{ result().labourHours | number:'1.0-1' }} Std.)</span>
            <span>– {{ result().labourCost | currency:'EUR':'symbol':'1.2-2' }}</span>
          </div>
        }
        <div class="mb-row mb-total">
          <span i18n="@@rechner.rows.surplus">Überschuss pro Monat</span>
          <span>{{ result().monthlySurplus | currency:'EUR':'symbol':'1.0-0' }}</span>
        </div>
      </div>

      <div class="mb-compare">
        <div class="mb-box" [class.mb-win]="buyAfter12() >= rentAfter12()">
          <h4 i18n="@@rechner.compare.buy.title">Kauf · 6.800 €</h4>
          <div class="mb-num">{{ buyAfter12() >= 0 ? '+' : '–' }}{{ abs(buyAfter12()) | currency:'EUR':'symbol':'1.0-0' }}</div>
          <div class="mb-cap" i18n="@@rechner.compare.buy.caption">Ergebnis nach 12 Monaten (inkl. Anschaffung)</div>
        </div>
        <div class="mb-box" [class.mb-win]="rentAfter12() > buyAfter12()">
          <h4 i18n="@@rechner.compare.rent.title">Miete · 300 €/Mon.</h4>
          <div class="mb-num">{{ rentAfter12() >= 0 ? '+' : '–' }}{{ abs(rentAfter12()) | currency:'EUR':'symbol':'1.0-0' }}</div>
          <div class="mb-cap" i18n="@@rechner.compare.rent.caption">Ergebnis nach 12 Monaten Laufzeit</div>
        </div>
      </div>

      <p class="mb-hint mb-switch" i18n="@@rechner.switch.hint">
        In den ersten <strong>{{ result().buyBeatsRentFromMonth | number:'1.0-0' }} Monaten</strong>
        ist Miete günstiger, danach der Kauf – unabhängig davon, wie gut die Box läuft.
        Die Miete hält Ihr Kapital frei, der Kauf ist ab Jahr 2 die billigere Variante.
      </p>

      <div class="mb-chart">
        <div class="mb-legend">
          <span><i class="mb-i-buy"></i><ng-container i18n="@@rechner.legend.buy">Kauf</ng-container></span>
          <span><i class="mb-i-rent"></i><ng-container i18n="@@rechner.legend.rent">Miete</ng-container></span>
          <span><i class="mb-i-zero"></i><ng-container i18n="@@rechner.legend.zero">Break-even-Linie</ng-container></span>
        </div>
        <svg viewBox="0 0 460 210" width="100%" role="img"
             i18n-aria-label="@@rechner.chart.ariaLabel" aria-label="Kumulierter Cashflow über 36 Monate">
          @for (line of chart().gridLines; track line.y) {
            <line [attr.x1]="44" [attr.y1]="line.y" [attr.x2]="452" [attr.y2]="line.y" stroke="#eef2f0"/>
            <text [attr.x]="38" [attr.y]="line.y + 3.5" text-anchor="end" font-size="9" fill="#8b9a92">
              {{ line.label }}
            </text>
          }
          <line [attr.x1]="44" [attr.y1]="chart().zeroY" [attr.x2]="452" [attr.y2]="chart().zeroY"
                stroke="#cbd5d0" stroke-dasharray="3 3"/>
          @for (tick of chart().monthTicks; track tick.x) {
            <text [attr.x]="tick.x" [attr.y]="204" text-anchor="middle" font-size="9" fill="#8b9a92">
              {{ tick.label }}
            </text>
          }
          <path [attr.d]="chart().rentPath" fill="none" stroke="#94a3ae" stroke-width="2"/>
          <path [attr.d]="chart().buyPath" fill="none" stroke="var(--mb-accent)" stroke-width="2.5"/>
          @if (chart().breakeven; as be) {
            <circle [attr.cx]="be.x" [attr.cy]="be.y" r="4"
                    fill="var(--mb-accent)" stroke="#fff" stroke-width="2"/>
          }
        </svg>
      </div>
    </div>
  </div>

  <!-- ================= LEAD ================= -->
  <div class="mb-cta">
    <h3 i18n="@@rechner.cta.title">Ihre Rechnung als PDF – plus Standort-Checkliste</h3>
    <p i18n="@@rechner.cta.text">Wir schicken Ihnen Ihre Kalkulation im Detail und was den Umsatz an Ihrem Standort realistisch macht.</p>

    @if (formState() === 'done') {
      <div class="mb-ok" i18n="@@rechner.cta.done">Danke – ist unterwegs zu Ihnen.</div>
    } @else {
      <form class="mb-form" (ngSubmit)="submit()">
        <input type="email" name="email" i18n-placeholder="@@rechner.cta.placeholder" placeholder="ihre@email.de" required
               [ngModel]="email()" (ngModelChange)="email.set($event)">
        <button type="submit" [disabled]="formState() === 'sending'">
          @if (formState() === 'sending') {
            <ng-container i18n="@@rechner.cta.sending">Wird gesendet …</ng-container>
          } @else {
            <ng-container i18n="@@rechner.cta.submit">Rechnung zuschicken</ng-container>
          }
        </button>
      </form>
    }
    <p class="mb-legal" i18n="@@rechner.cta.legal">Kein Newsletter-Zwang, keine Weitergabe. Abmeldung jederzeit.</p>
  </div>
</div>
